import React, { useMemo, useState, useEffect } from "react";

import AxiosApiClient from '../../utils/AxiosApiClient';
import PodcastHeader from "./PodcastHeader";
import PodcastEpisode from "./PodcastEpisode";
import PodcastPlayer from "./PodcastPlayer";
import LoadingSpinner from '../LoadingSpinner';

import { podcastResources } from "../../../resources/podcastResources";

const INITIAL_EPISODES = 4;

export default function Podcast({resourceId}) {

    const resource = podcastResources[resourceId];

    const [isLoading, setIsLoading] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    const [episodes, setEpisodes] = useState(null);
    const [currentEpisode, setCurrentEpisode] = useState(null);
    const [showAllEpisodes, setShowAllEpisodes] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [search, setSearch] = useState("");
    const [sortOrder, setSortOrder] = useState("newest");

    // Initial Call For Pdocast Episodes ==========================================================
    useEffect(() => {

        setIsLoading(true);

        if (isMounted && resource) {

            console.log('[PodcastSharing - useEffect] mounted');

            var resource_endPoint = resource.endpoint;
            console.log('[PodcastSharing - useEffect] resource_endPoint: ', resource_endPoint);

            var auth_api = 'phpLaravel';
            if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
                auth_api = localStorage.getItem('auth_api');
            }

            const fetchPodcastEpisodesApiData = async () => {
                try {
                    const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
                    await getBearerToken();
                    const response = await makeRequestWithHeaders('get', resource_endPoint, null, {});

                    setPodcastEpisodesApiData(response);
                } catch (error) {
                    handlePodcastEpisodesApiError(error);
                }
            };

            fetchPodcastEpisodesApiData();

        } else {
            setIsMounted(true);
        }

    }, [isMounted, resource]);
    function setPodcastEpisodesApiData(response, theFunction) {
        if (response && response.data) {
            if (response.status === 200) {//HTTP_OK
                console.log(theFunction + ': ', response.data.api_message);

                const episodes = response.data.episodes;

                setEpisodes(episodes);
            } else if (response.status === 401) {//HTTP_UNAUTHORIZED
                console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');
            } else if (response.status === 800) {//HTTP_FORM_VALIDATION_FAILED
                console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');
            } else {//more errors
            }
        }

        setIsLoading(false);
    }
    function handlePodcastEpisodesApiError(error, theFunction) {
        console.log(theFunction + ' error: ', error + ' back-end api call error');

        setIsLoading(false);
    }
    // End Podcast Episodes ==========================================================

    const filteredEpisodes = useMemo(() => {

        if (!episodes) {
            return [];
        }

        let data = [...episodes];

        if (search !== "") {
            const term = search.toLowerCase();
            data = data.filter(ep =>
                ep.title.toLowerCase().includes(term) ||
                ep.description.toLowerCase().includes(term)
            );
        }

        if (sortOrder === "oldest") {
            data.sort((a, b) =>
                new Date(a.published) - new Date(b.published));
        }

        if (sortOrder === "newest") {
            data.sort((a, b) =>
                new Date(b.published) - new Date(a.published));
        }

        return data;

    }, [episodes, search, sortOrder]);

    const displayedEpisodes = showAllEpisodes
        ? filteredEpisodes
        : filteredEpisodes.slice(0, INITIAL_EPISODES);

    function handleEpisodeSelected(episode) {

        if (
            currentEpisode &&
            currentEpisode.guid === episode.guid
        ) {
            setIsPlaying(true);
            return;
        }

        setCurrentEpisode(episode);
        setIsPlaying(true);

    }
    function handleTogglePlayPause() {
        setIsPlaying(previous => !previous);
    }
    //-------------------------------------------------------

    return (

        <div className="podcast">
            {/*}
            <PodcastHeader
                episodeCount={episodes.length}
                search={search}
                setSearch={setSearch}
                sortOrder={sortOrder}
                setSortOrder={setSortOrder}
            />
*/}

            <PodcastPlayer
                episode={currentEpisode}
                isPlaying={isPlaying}
                setIsPlaying={setIsPlaying}
            />

            {isLoading &&
                <>
                    <div className="font-raleway font-size-20l-18m-16s font-weight-600 txt-fff align-center line-height-125per pt-20">
                        Loading Podcast
                    </div>
                    <div className="pt-20">
                        <LoadingSpinner />
                    </div>
                </>
            }

            {!isLoading && episodes && episodes.length !== 0 && (
                <div className="episode-list pt-20">
                    {displayedEpisodes.map(episode => (
                        <PodcastEpisode
                            key={episode.guid}
                            episode={episode}
                            currentEpisode={currentEpisode}
                            isPlaying={isPlaying}
                            onEpisodeSelected={handleEpisodeSelected}
                            onTogglePlayPause={handleTogglePlayPause}
                        />
                    ))
                    }
                </div>
            )}
            {!isLoading && episodes && episodes.length !== 0 && filteredEpisodes.length > INITIAL_EPISODES && (

                <div className="episode-description-toggle hover-opacity-50 font-raleway font-size-20l-18m-16s font-weight-600 txt-fff align-center line-height-125per pt-10"

                    onClick={() =>
                        setShowAllEpisodes(previous => !previous)
                    }
                >

                    <span>
                        {
                            showAllEpisodes
                                ? "Show Less Episodes"
                                : `Show ${filteredEpisodes.length -
                                INITIAL_EPISODES
                                } More Episodes`

                        }

                    </span>

                    <span className="episode-chevron pl-5">
                        {showAllEpisodes
                            ? "▲"
                            : "▼"
                        }
                    </span>
                </div>

            )}

        </div>

    );

}